import * as cohort from '../../actionTypes/Cohort/Cohort';

const initialCohortState = {
  cohorts: [
    {
      id: 0,
      name: 'create',
    },
  ],
};

export default function cohortReducer(state = initialCohortState, action) {
  switch (action.type) {
    case cohort.GET_COHORT:
      return { ...state, cohorts: action.cohorts };
    default:
      return state;
  }
}
